// @flow
'use strict';

import { connect } from 'react-redux';

import ListaNfce from './lista';

export default connect<*, *, *, *, *, *>()(ListaNfce);
